import { render, staticRenderFns } from "./IconCellRenderer.vue?vue&type=template&id=bcb20bd6"
import script from "./IconCellRenderer.vue?vue&type=script&lang=js"
export * from "./IconCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports